<template>
	<g>
		<circle style="fill:#21D0C3;" cx="256" cy="256" r="256"/>
		<path style="fill:#FFFFFF;" d="M252.442,305.805H185.31h-3.062v3.064v47.326h6.126v-44.263h64.068v61.81v81.495h6.126v-81.495
			v-23.523h64.067v44.263h6.126v-47.326v-3.064h-3.064h-67.129V225.146h-6.126V305.805z"/>
		<path id="iconCloud--el" style="fill:#0F7986;" d="M255.503,475.702c6.353,0,11.5-5.149,11.5-11.5c0-6.351-5.148-11.502-11.5-11.502
			s-11.5,5.15-11.5,11.502C244.003,470.554,249.151,475.702,255.503,475.702z"/>
		<path style="fill:#FFFFFF;" d="M143.05,284.901H83.365v6.126h59.684v50.645h6.127V192.388h-6.127L143.05,284.901L143.05,284.901z"/>
		<path style="fill:#FAD24D;" d="M146.114,353.171c6.352,0,11.5-5.149,11.5-11.5c0-6.353-5.149-11.502-11.5-11.502
			c-6.353,0-11.503,5.149-11.503,11.502C134.611,348.023,139.761,353.171,146.114,353.171z"/>
		<path id="iconCloud--el" style="fill:#0F7986;" d="M83.498,299.991c6.353,0,11.502-5.149,11.502-11.502c0-6.352-5.149-11.5-11.502-11.5
			c-6.352,0-11.5,5.149-11.5,11.5C71.997,294.842,77.146,299.991,83.498,299.991z"/>
		<path style="fill:#FFFFFF;" d="M367.493,284.901h59.684v6.126h-59.684v50.645h-6.127V192.388h6.127V284.901z"/>
		<path id="iconCloud--el" style="fill:#0F7986;" d="M364.429,352.985c-6.248,0-11.311-5.065-11.311-11.313c0-6.249,5.064-11.314,11.311-11.314
			c6.249,0,11.314,5.065,11.314,11.314C375.743,347.919,370.678,352.985,364.429,352.985z"/>
		<path id="iconCloud--el" style="fill:#FF5B62;" d="M427.045,300.052c-6.387,0-11.562-5.176-11.562-11.562c0-6.386,5.176-11.561,11.562-11.561
			c6.386,0,11.561,5.176,11.561,11.561C438.606,294.876,433.43,300.052,427.045,300.052z"/>

		<g id="iconCloud--cloud">
			<path style="fill:#ECF0F1;" d="M109.433,177.179c0.559,0,1.112,0.013,1.665,0.038c8.189-22.901,30.066-39.285,55.78-39.285
				c6.851,0,13.432,1.168,19.551,3.309c6.895-49.05,49.024-86.798,99.978-86.798c53.738,0,97.67,41.985,100.788,94.942
				c28.657,1.028,51.568,24.576,51.568,53.483c0,29.559-23.96,53.52-53.52,53.52c-94.808,0-181.539,0-275.809,0
				c-21.873,0-39.603-17.731-39.603-39.604S87.561,177.178,109.433,177.179L109.433,177.179z"/>
			<path style="fill:#FFFFFF;" d="M107.229,171.885c0.558,0,1.111,0.014,1.663,0.038c8.189-22.899,30.066-39.284,55.781-39.284
				c6.85,0,13.431,1.167,19.551,3.309c6.894-49.051,49.024-86.798,99.977-86.798c53.739,0,97.672,41.985,100.789,94.942
				c28.655,1.027,51.567,24.575,51.567,53.483c0,29.559-23.96,53.52-53.52,53.52c-94.806,0-181.537,0-275.807,0
				c-21.873,0-39.604-17.731-39.604-39.604S85.355,171.884,107.229,171.885L107.229,171.885z"/>
		</g>

		<path style="fill:#FAD24D;" d="M326.03,406.084c-6.387,0-11.562-5.176-11.562-11.562c0-6.386,5.176-11.561,11.562-11.561
			c6.386,0,11.561,5.176,11.561,11.561C337.592,400.908,332.416,406.084,326.03,406.084z"/>
		<path id="iconCloud--el" style="fill:#FF5B62;" d="M185.492,368.186c-6.387,0-11.562-5.176-11.562-11.562c0-6.386,5.176-11.561,11.562-11.561
			c6.386,0,11.561,5.176,11.561,11.561C197.053,363.01,191.877,368.186,185.492,368.186z"/>
	</g>
</template>

<script>
	import { TimelineMax  } from 'gsap'

	export default {
		name: "Cloudicon",
		data: function () {
			return {
				tl:undefined,
			}
		},
		methods: {
			start() {
				this.tl = new TimelineMax({repeat: -1});
				this.tl.to('#iconCloud--cloud',1, { scale: 1.03, transformOrigin: "center" });
				this.tl.to('#iconCloud--el', 0.5, { fill: "rgb(240,248,255)" }, "-=0.5");
			},
			stop() {
				this.tl.kill();
			},
			pause() {
				this.tl.pause();
			},
			play() {
				if (this.tl.paused()) {
					this.tl.play();
				}
			}
		},
		computed: {

		}
	}
</script>

<style scoped>

</style>
